import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { apiUrl } from "../apiUrl";

export const getAllVacunas = createAsyncThunk(
  "vacunas/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/api/v1/vacunas`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

const vacunasSlice = createSlice({
  name: "vacunas",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllVacunas.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllVacunas.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getAllVacunas.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: "Fallo al cargar las vacunas",
        };
        state.data = [];
      });
  },
});

export default vacunasSlice.reducer;
